module.exports = "<p>\r\n  awsop-lab16 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab16/awsop-lab16.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab16/awsop-lab16.component.html
// module chunks = main